document.addEventListener('change', event => {
  if (event.target.id !== 'VariantSelect') return;
  const option = event.target.selectedOptions[0];
  const scope = event.target.closest('.product-details');
  scope.querySelector('[data-product-price]').textContent = option.dataset.price;
  scope.querySelector('[data-product-sku]').textContent = option.dataset.sku;
  const button = scope.querySelector('[data-product-button]');
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
});
document.addEventListener('click', event => {
  document.querySelectorAll('.brand-nav[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.brand-nav[open], .mobile-nav[open]').forEach(menu => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

function setupEditorialHeader(){
 document.querySelectorAll('[data-editorial-header]').forEach(header=>{
 if(header.dataset.ready)return;header.dataset.ready='true';
 const menus=[...header.querySelectorAll('.er-mega')];
 const sync=()=>header.classList.toggle('er-menu-open',menus.some(m=>m.open));
 const hoverEnabled=()=>window.matchMedia('(hover: hover) and (pointer: fine)').matches;
 const openDelay=350;
 const closeDelay=350;
 let openTimer,closeTimer,pendingMenu;
 const cancelOpen=()=>{window.clearTimeout(openTimer);pendingMenu=null};
 const cancelClose=()=>window.clearTimeout(closeTimer);
 const cancelTimers=()=>{cancelOpen();cancelClose()};
 const closeAll=()=>{cancelTimers();menus.forEach(menu=>menu.open=false);sync()};
 const openMenu=menu=>{cancelTimers();menus.forEach(other=>other.open=other===menu);sync()};
 const scheduleClose=()=>{
  cancelClose();
  closeTimer=window.setTimeout(()=>{
   if(menus.some(menu=>menu.open&&menu.querySelector('.er-mega-panel')?.contains(document.activeElement)))return;
   closeAll();
  },closeDelay);
 };
 menus.forEach(menu=>{
  menu.addEventListener('pointerenter',event=>{
   if(event.pointerType==='touch'||!hoverEnabled())return;
   cancelTimers();
   if(menu.open||menu.hidden)return;
   pendingMenu=menu;
   openTimer=window.setTimeout(()=>{if(pendingMenu===menu&&!menu.hidden)openMenu(menu)},openDelay);
  });
  menu.addEventListener('pointerleave',event=>{
   if(event.pointerType==='touch'||!hoverEnabled())return;
   if(pendingMenu===menu)cancelOpen();
   scheduleClose();
  });
  menu.querySelector('.er-mega-panel')?.addEventListener('pointerenter',cancelTimers);
  menu.querySelector('summary')?.addEventListener('click',cancelTimers);
  menu.addEventListener('toggle',()=>{if(menu.open)menus.forEach(other=>{if(other!==menu)other.open=false});sync()});
  menu.querySelector('.er-mega-close')?.addEventListener('click',()=>{closeAll();menu.querySelector('summary')?.focus()});
 });
 header.addEventListener('pointerleave',event=>{
  if(event.pointerType==='touch'||!hoverEnabled())return;
  cancelOpen();
  scheduleClose();
 });
 header.addEventListener('focusin',event=>{
  cancelTimers();
  menus.forEach(menu=>{if(!menu.contains(event.target))menu.open=false});
  sync();
 });
 header.addEventListener('focusout',event=>{if(!header.contains(event.relatedTarget))closeAll()});
 header.querySelectorAll('[data-mode]').forEach(button=>button.addEventListener('click',()=>{
  closeAll();
  header.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  menus.forEach(m=>m.hidden=m.dataset.menuMode!==button.dataset.mode);
 }));
 header.querySelectorAll('[data-helmet-menu]').forEach(menu=>{
  const styles=[...menu.querySelectorAll('[data-helmet-style]')];
  const activate=button=>{styles.forEach(style=>style.setAttribute('aria-pressed',String(style===button)));menu.querySelectorAll('[data-helmet-panel]').forEach(panel=>panel.hidden=panel.dataset.helmetPanel!==button.dataset.helmetStyle)};
  styles.forEach(button=>{button.addEventListener('pointerenter',event=>{if(event.pointerType!=='touch'&&hoverEnabled())activate(button)});button.addEventListener('focus',()=>activate(button));button.addEventListener('click',()=>activate(button))});
 });
 const ride=header.querySelector('[data-open-ride]');ride.addEventListener('click',()=>{header.querySelector('[data-mode="shop"]').click();const menu=menus.find(m=>m.querySelector('.er-vehicle-finder'));if(menu){menu.hidden=false;openMenu(menu)}});
 document.addEventListener('click',event=>{if(!header.contains(event.target))closeAll()});
 header.addEventListener('keydown',event=>{if(event.key==='Escape'){const open=menus.find(m=>m.open);closeAll();if(open)open.querySelector('summary').focus()}});
 });
}
setupEditorialHeader();document.addEventListener('shopify:section:load',setupEditorialHeader);


(() => {const params=new URL(location.href).searchParams;const helmet=params.get('helmet');const body=document.querySelector('[name="contact[body]"]');if(helmet&&body&&!body.value){const lines=[helmet,params.get('finish'),params.get('size'),params.get('part')].filter(Boolean);body.value=lines.join(' / ');}})();
